import { clsx } from "clsx";

export default function TextDisclaimer({
  children,
  className,
}: React.PropsWithChildren<{
  children: React.ReactNode;
  className?: string;
}>) {
  return (
    <div className={clsx("text-[10px]/[16px]", className)}>{children}</div>
  );
}
